export const documentMaxValue: number = 2000000000;
export const documentNameMaxLength: number = 255;

export const contentLinkTitleMaxLength: number = 100;
export const contentLinkButtonTextMaxLength: number = 50;

export const fieldLabelMaxLength: number = 100;
export const fieldValidationWarningMaxLength: number = 255;
